// extracted by mini-css-extract-plugin
module.exports = {"content":"Product_content__3Q0m7","submitBtn":"Product_submitBtn__18U25","checkbox":"Product_checkbox__kvH99"};